import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { RaceInfo } from '../components/RaceInfo';
import { RacingClasses } from '../components/RacingClasses';
import { CompetitionMap } from '../components/CompetitionMap';
import { TeamSponsors } from '../components/TeamSponsors';
import { ContactForm } from '../components/ContactForm';
import { PhotoGallery } from '../components/PhotoGallery';
import { Footer } from '../components/Footer';
import { LanguageProvider } from '../context/LanguageContext';
export function HomePage() {
  return <LanguageProvider data-id="element-773">
      <div className="min-h-screen w-full bg-black" data-id="element-774">
        <Navbar data-id="element-775" />
        <main data-id="element-776">
          <HeroSection data-id="element-777" />
          <RaceInfo data-id="element-778" />
          <RacingClasses data-id="element-779" />
          <CompetitionMap data-id="element-780" />
          <TeamSponsors data-id="element-781" />
          <ContactForm data-id="element-782" />
          <PhotoGallery data-id="element-783" />
        </main>
        <Footer data-id="element-784" />
      </div>
    </LanguageProvider>;
}